var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPriority(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19399 0.598537V1.19707L8.0384 1.20186L12.8828 1.20665L11.5653 2.96333L10.2478 4.71998L11.5665 6.47466C12.2918 7.43971 12.8852 8.23331 12.8852 8.23818C12.8852 8.24304 10.7047 8.24703 8.03959 8.24703H3.19399V8.84561V9.44418H9.23786C14.068 9.44418 15.2788 9.43941 15.2672 9.42043C15.2593 9.40737 14.4693 8.35344 13.5118 7.07839C12.5543 5.80333 11.7647 4.74959 11.7571 4.73672C11.7485 4.72213 12.3876 3.85564 13.4591 2.42902C14.4029 1.17264 15.1992 0.112133 15.2289 0.0723421L15.2828 0H9.2384H3.19399V0.598537ZM0.666672 8.019V16H1.26525H1.86382V8.019V0.0380047H1.26525H0.666672V8.019Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriority);
export default __webpack_public_path__ + "static/media/icon--priority.0f3ebc421edbca53070d24d01450cfda.svg";
export { ForwardRef as ReactComponent };